import React, {useEffect, useState} from 'react';
import CanvasJSChart from "../dashboard/CanvasJSChart";
import SpinnerDiv from "../gdpr/ui/SpinnerDiv";
import {getPanelHeader} from "./DashboardPanelFunctions";
import {getDataFromResponse} from "../DataFunctions/BaseDataFns";
import VSFallbackComponent from "./FallbackComponent";
import {ErrorBoundary} from "react-error-boundary";
import {getResourceUsage} from "../DataFunctions/StatisticsDataFns";
import DropdownSchools from "./ui/DropdownSchools";
import DropdownSchoolGroups from "./ui/DropdownSchoolGroups";
import DropdownGroupPupils from "./ui/DropdownlGroupPupils";
import './AdminDashboard.scss'
import {UserTypes} from "../globals";
import {getColorForResource} from "./GraphCommonFns";

const ResourcePupilUsageYearSummary = (props) =>
{
    const [data, setData] = useState({loading: true, data: [], dataPoints: []})
    const [ school_id, setSchoolId ] = useState ( props.school_id) ;
    const [ group_id, setGroupId ] = useState ( 0) ;
    const [ pupil_uid, setPupilUId ] = useState ( 0) ;

    useEffect(() =>
    {
        getServerData(school_id, group_id, pupil_uid);
    }, [school_id, group_id, pupil_uid]);

    const mapDataForResourceType = (arr) =>
    {
        const dataPoints = arr === undefined || arr.length === 0 ? [] : arr.map((item) => {
            const obj = {};
            const key = item.monkey;
            obj.y = +(item.count);
            const yr = key.substr(0, 4);
            const mo = key.substr(4, 2);
            obj.x = new Date(yr, +mo - 1);
            return obj;
        })

        return dataPoints;
    }

    const toolTipContent = (e) =>
    {
        const getMonthName = (month) =>
        {
            const monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];

            return monthNames[month];
        }

        let str = "";
        let total = 0;

        let str2;

        for (let i = 0; i < e.entries.length; i++)
        {
            const str1 = "<span style= \"color:" + e.entries[i].dataSeries.color + "\"> " + e.entries[i].dataSeries.name + "</span>: <strong>" + e.entries[i].dataPoint.y + "</strong><br/>";
            total = e.entries[i].dataPoint.y + total;
            str = str.concat(str1);
        }
        str2 = "<span style = \"color:DodgerBlue;\"><strong>" + getMonthName((e.entries[0].dataPoint.x).getMonth()) + ' ' + (e.entries[0].dataPoint.x).getFullYear() + "</strong></span><br/>";

        total = Math.round(total * 100) / 100;

        const str3 = "<span style = \"color:Tomato\">Total:</span><strong> " + total + "</strong><br/>";
        return (str2.concat(str)).concat(str3);
    }

    const getServerData = (school_id, group_id, pupil_uid) =>
    {
        const user_type = UserTypes.USER_TYPE_CHILD;
        const selected_school = school_id === undefined ? props.school_id : school_id;

        getResourceUsage(selected_school, group_id, props.resource_type, user_type,'summary', null, pupil_uid, (response) =>
        {
            const reportData = getDataFromResponse(response);

            const stackedData = reportData.map((myObj) =>
            {
                const item = {
                    type: "stackedColumn",
                    showInLegend: true,
                    name: myObj.name,
                    color: getColorForResource(myObj),
                    dataPoints: mapDataForResourceType(myObj.year)
                }
                return item;
            })

            setData({loading: false, dataPoints: stackedData, data: reportData});
        });
    }

    const formPanel = () =>
    {
        var options = {
            animationEnabled: true,
            exportEnabled: true,
            height: 400,
            axisX: {
                interval: 1,
                intervalType: "month"
            },
            axisY: {
                gridColor: "#B6B1A8",
                tickColor: "#B6B1A8",
            },
            toolTip: {
                shared: true,
                content: toolTipContent
            },
            data: data.dataPoints
        };

        const onSchoolDropdownChange = ( evt, options ) =>
        {
            if ( options.action === 'select-option')
            {
                const value = evt.value;
                setSchoolId ( value) ;
            }
        };

        const onGroupDropdownChange = ( evt, options ) =>
        {
            if ( options.action === 'select-option')
            {
                const value = evt.value;
                setGroupId ( value) ;
                setPupilUId(0);
            }
        };

        const onPupilDropdownChange = ( evt, options ) =>
        {
            if ( options.action === 'select-option')
            {
                const value = evt.value;
                setPupilUId ( value) ;
            }
        };

        return (
            <ErrorBoundary FallbackComponent={VSFallbackComponent}>
                <div className={'panel ' + props.panelStyle}>
                    {props.title !== '' && getPanelHeader({title: props.title})}
                    <div className='panel-body'>
                        <div className='col-md-12'>
                            <CanvasJSChart id='chartCareersAdvice' options={options} uniqueId='canvasResourceUsage'/>
                            {data.data.length === 0 && <div> <h4>Sorry there was no data found for this choice.</h4></div>}
                        </div>
                    </div>

                    <div className='panel-body'>
                        { props.school_id === 0 && <div className='col-md-6'>
                            <DropdownSchools onChange={onSchoolDropdownChange}
                                                  id='InputSchoolDropdown'
                                                  label='Select a School'
                                                  defaultValue={0}
                                                  isClearable={false}
                                                  value={school_id}
                                                  readOnly={''}
                                                  key='InputSchoolDropdown'
                                                  renderErrorDiv={false}
                                                  menuPlacement={'top'}/>
                        </div>}

                        { props.school_id !== 0 && <div className='col-md-6'>
                            <DropdownSchoolGroups onChange={onGroupDropdownChange}
                                            id='InputGroupDropdown'
                                            label='Select a Group'
                                            defaultValue={group_id}
                                            isClearable={false}
                                            value={group_id}
                                            readOnly={''}
                                            key='InputGroupDropdown'
                                            renderErrorDiv={false}
                                            menuPlacement={'top'}
                                            school_id={props.school_id}/>
                        </div>}

                        { props.school_id !== 0 && <div className='col-md-6'>
                            <DropdownGroupPupils onChange={onPupilDropdownChange}
                                                  id='InputPupilDropdown'
                                                  label='Select a Pupil'
                                                  defaultValue={0}
                                                  isClearable={false}
                                                  value={pupil_uid}
                                                  readOnly={''}
                                                  key='InputPupilpDropdown'
                                                  renderErrorDiv={false}
                                                  menuPlacement={'top'}
                                                  group_id={group_id}/>
                        </div>}
                    </div>
                </div>
            </ErrorBoundary>
        )
    }

    return data.loading === true ? <SpinnerDiv/> : formPanel();
}

export default ResourcePupilUsageYearSummary;

ResourcePupilUsageYearSummary.defaultProps =
    {
        title: 'title',
        panelStyle: 'panel-default',
        data: {}
    }